import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ClockLoader from "react-spinners/ClockLoader";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { gtag } from "ga-gtag";

import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import Widget from "../ui/widget";
import WidgetContent from "../ui/widgetContent";
import WidgetTitle from "../ui/widgetTitle";

const UserUnsubscribe = props => {
  const { inviteKey, unsubscibeStatus, unsubscribeSuccess, unsubscribeUserRequest } = props;

  const theme = useTheme();
  // const [unsubscribeComplete, setUnsubscribeComplete] = useState(null);

  useEffect(() => {
    if (inviteKey != null && !unsubscribeSuccess) {
      //swap to unsubscribe
      unsubscribeUserRequest(inviteKey);
    } else if (inviteKey != null && unsubscribeSuccess) {
      gtag("event", "omni_unsubscribe_complete", { invite_key: `${inviteKey}` });
    }
  }, [inviteKey, unsubscribeSuccess, unsubscribeUserRequest]);

  return (
    <Widget widgetSize="large">
      <WidgetTitle title={"Omniscia Health"} text={"Updating your preferences..."} />

      <WidgetContent>
        {!unsubscribeSuccess && (
          <Box
            sx={{
              paddingTop: "15%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <ClockLoader color={theme.palette.background.contrastText} loading={true} size={200} />
            {unsubscibeStatus}
          </Box>
        )}
        {unsubscribeSuccess && (
          <Box
            sx={{
              paddingTop: "15%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">You have been sucessfully unsubscribed.</Typography>
          </Box>
        )}
      </WidgetContent>
    </Widget>
  );
};

const mapStateToProps = state => ({
  // onboardingODM: state.onboardingSession.onboardingODM,
  inviteKey: state.onboardingSession.inviteKey,
  unsubscibeStatus: state.onboardingSession.unsubscibeStatus,
  unsubscribeSuccess: state.onboardingSession.unsubscribeSuccess,
});

const mapDispatchToProps = {
  unsubscribeUserRequest: OnboardingSessionActions.unsubscribeUserRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserUnsubscribe));
